import React from 'react';
import { cx } from './classNames';
import './ui.css';

/* title は ReactNode を受けたいので、string 固定の DOM 属性側を外す（Button と同じ扱い） */
export interface EmptyStateProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  /** lucide のアイコン要素。56px のタイルに収める */
  icon: React.ReactNode;
  title: React.ReactNode;
  description?: React.ReactNode;
  /** 次の一手（主ボタンなど） */
  action?: React.ReactNode;
}

export function EmptyState({ icon, title, description, action, className, ...rest }: EmptyStateProps) {
  return (
    <div className={cx('ui-empty', className)} {...rest}>
      <div className="ui-empty__icon" aria-hidden="true">
        {icon}
      </div>
      <h3 className="ui-empty__title">{title}</h3>
      {description != null && <p className="ui-empty__desc">{description}</p>}
      {action != null && <div className="ui-empty__action">{action}</div>}
    </div>
  );
}
